import React from 'react';
import { Card, Table, Typography, Empty } from 'antd';
import dayjs from 'dayjs';
import { useTicketClicksReport, TicketClickReportRow } from '@shared/api/hooks/useMatches';

export function TicketStatsPage(): React.ReactElement {
  const { data, isLoading } = useTicketClicksReport();
  const rows = data ?? [];

  return (
    <div style={{ padding: 24 }}>
      <Typography.Title level={3} style={{ marginBottom: 4 }}>
        Statistiche Biglietti
      </Typography.Title>
      <Typography.Text type="secondary">
        Click sul bottone &quot;Acquista biglietti&quot; per partita (conteggio anonimo aggregato).
      </Typography.Text>

      <Card style={{ marginTop: 16 }}>
        <Table<TicketClickReportRow>
          rowKey="matchId"
          loading={isLoading}
          dataSource={rows}
          locale={{ emptyText: <Empty description="Nessuna partita con URL biglietti impostato" /> }}
          pagination={false}
          scroll={{ x: 'max-content' }}
          columns={[
            {
              title: 'Partita',
              key: 'match',
              render: (_, r) => (
                <div>
                  <div>{r.homeTeamName} — {r.awayTeamName}</div>
                  <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                    {dayjs(r.date).format('DD/MM/YYYY HH:mm')}
                  </Typography.Text>
                </div>
              ),
            },
            {
              title: 'URL biglietti',
              dataIndex: 'ticketUrl',
              render: (url: string) => (
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {url}
                </a>
              ),
            },
            {
              title: 'Click totali',
              dataIndex: 'totalClicks',
              align: 'right' as const,
              sorter: (a: TicketClickReportRow, b: TicketClickReportRow) =>
                a.totalClicks - b.totalClicks,
            },
          ]}
        />
      </Card>
    </div>
  );
}
